import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { connectUrlParams } from 'utils/constants/urls';

const LOGIN_PICKER_PATH = '/login';

const getPickerUrl = (previousLocation?: string): string => {
  if (!previousLocation) return `${LOGIN_PICKER_PATH}${window.location.search}`;

  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set(connectUrlParams.RETURN_TO, previousLocation);
  return `${LOGIN_PICKER_PATH}?${searchParams.toString()}`;
};

const LoginHandoff: React.FC = () => {
  const { state } = useLocation<{ previousLocation?: string } | undefined>();
  const previousLocation = state?.previousLocation;

  useEffect(() => {
    window.location.replace(getPickerUrl(previousLocation));
  }, [previousLocation]);

  return null;
};

export default LoginHandoff;
